<template>
  <div class="word-test">
    <div class="word-test-wrap">
      <div class="word-test-wrap-main w1200" v-if="page === 'start-page'">
        <div class="word-test-page-start">
          <div class="word-test-area-hd">
            <img src="~assets/word_test/word_test_cover.png"/>
          </div>
          <div class="word-test-area-bd">
            <div class="word-test-area-bd-title">测测你的词汇量</div>
            <div class="word-test-area-bd-desc">5分钟了解一下自己的词汇量吧～</div>
          </div>
          <div class="word-test-area-ft">
            <button class="start-test-btn" @click="startExam">开始测评</button>
          </div>
        </div>
      </div>
      <div class="word-test-wrap-main w1200" v-if="page==='testing-page'">
        <div class="word-test-page-testing">
          <div class="test-ab-circle"></div>
          <div class="test-ab-circle-daojishi">
            <img src="~assets/word_test/daojishi-icon.png">
            <span class="daojishi">{{ gameSecond }}</span>
          </div>
          <div class='test-subject-title'>
            <div class='audio-text' v-if="isListen === 0">{{ wordCur.subject }}</div>
            <div class='audio-img' v-if="isListen === 1" @click='playOne'>
              <img src="~assets/word_test/laba-icon.png">
            </div>
          </div>
          <div class="test-options">
            <div
              v-for="(item,index) in wordCur.options"
              class="test-options-option"
              v-bind:class="{ 'touchClass': index==selectedIndex}"
              :data-index='index'
              @click='clickOption'>
              <span class='circle-icon'></span>
              <span class='text'>{{ item }}</span>
            </div>
            <div class='test-options-option test-options-option-unknown' @click="clickUnknown">
              <span class='circle-icon'></span>
              <span class='text'>不认识</span>
            </div>
          </div>
        </div>
      </div>
      <div class="word-test-wrap-main word-test-wrap-main-result w1200" v-if="page==='end-page'">
        <div class="word-test-page-end">
          <img src="~assets/word_test/result-image.png" class="bg-image">
          <div class="word-test-result-layer">
            <div class="word-test-result-hd">
              <div class="result-student">
                <img v-bind:src="userInfo.avatar" alt="">
                <span class="result-username">{{ userInfo.username }} 同学</span>
              </div>
            </div>
            <div class="word-test-result-bd">
              <div class="test-you-cihuiliang">你的词汇量约为：</div>
              <div class="test-you-zhangwodeci">
                <div class="number">
                  <b>{{ zhang_wo_de_ci }}</b>
                  <span>词</span>
                </div>
                <div class="desc">击败了全国<span class="bili">{{ exam_rank }}%</span>的同学哦！</div>
              </div>
              <div class="text-content">
                <div class="title">{{ exam_shuiping }}</div>
                <div class="content">{{ exam_shuiping_content }}</div>
              </div>
            </div>
            <div class="word-test-result-ft">
              <button class="result-restart-button" @click="startExam">再测一次</button>
              <button class="result-more-button" @click="viewDetail">查看详细报告</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="word-test-footer">
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Footer from '@/components/layout/Footer'
import mTypes from '@/store/mutationsTypes'
import { mapState, mapMutations } from 'vuex'
import { getExamWords, getListenWords, submitTestResult, userLogin } from '@/services'

export default {
  name: 'word_test',
  components: {
    Footer,
  },
  data () {
    return {
      exam_detail_url: '',
      exam_shuiping_content: '同学的测评水平能写出便条和简单的书信。并且能尝试使用不同的教育资源，从口头和书面材料中提取信息扩展知识，能够解决简单的问题并描述结果。',
      exam_shuiping: '高中一年级水平',
      exam_rank: 10,
      zhang_wo_de_ci: 1900,
      page: 'start-page',
      select_mp3: 'https://777-wx-res.oss-cn-beijing.aliyuncs.com/word-test/MP3/selectsucc.mp3', //单词选中的音效
      success_mp3: 'https://777-wx-res.oss-cn-beijing.aliyuncs.com/word-test/MP3/end.mp3',
      imageUrl: 'https://777-wx-res.oss-cn-beijing.aliyuncs.com/exam',
      innerAudioContext: new Audio(),
      timer: '',
      type: 0,
      totalTime: 15, //每题总的答题时间15s
      limitTime: 8, //每题的过界时间
      gameSecond: 15, //当前用时
      answer_percent: 0.8, //8秒以下答对的分数取0.8
      curNum: 0, //当前第几题
      maxErrorNum: 10, //总答题结束错10个单词就结束
      levelErrorNum: 5, //每个level答错5个就结束
      listData: [], //总的测试词数据
      totalLevel: 7, //总共是多少个等级
      curLevel: 0, //当前是那个等级
      curLevelErrNum: 0, //当前等级错误的单词数
      totalErrorNum: 0, //总共错的个数
      wordCur: {}, //当前单词
      selectedIndex: -1, //当前选择的选项下标
      is_unknown_click: 0, //是否点击的是不认识， 0为默认，1为点击的不认识
      canClick: 0, //选项是否可点击
      is_hide: 1, //界面是否黑屏
      lastLevelDidWord: '', //结束时的最后一个等级测试学过的单词字符串‘，’分割
      score: 0, //单词分数
      isListen: 0, //是否是听力单词测试，默认 0是词汇量检测， 1为听力词汇量测试
      id: 0, //报告的id
      listenWordList: [], //听力单词列表
      listenScore: 0, //听力测试的分数--对的个数
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  watch: {},
  created () {
  },
  methods: {
    ...mapMutations([mTypes.loginModal]),
    answerAndJudge (is_right) {
      let isListen = this.isListen
      if (isListen === 0) {
        let curLevel = this.curLevel
        let levelSize = this.listData[curLevel].question.length
        let curNum = this.curNum
        if (curNum < levelSize - 1) {
          if (!is_right) {
            if (this.isErrorEnd()) {
              console.log('isErrorEnd')
              this.finishWordTest()
              return
            }
          } else {
            this.computeScore()
          }
          this.curNum = curNum + 1
        } else if (this.curNum === levelSize - 1) {
          //该等级结束  需要换下一个级别的单词
          if (curLevel < this.totalLevel - 1) {
            //有下一级别
            if (!is_right) {
              if (this.isErrorEnd()) {
                console.log('isErrorEnd')
                this.finishWordTest()
                return
              }
            } else {
              this.computeScore()
            }
            this.curLevelErrNum = 0 //新的级别错题数清零
            this.curLevel = curLevel + 1
            this.curNum = 0

          } else if (curLevel == this.totalLevel - 1) {
            //单词测试结束，计算成绩
            if (is_right) {
              this.computeScore()
            }
            console.log('select end')
            this.finishWordTest()
            return
          }
        }
        //下一题
        this.playNext()
      } else if (isListen == 1) {
        //如果是听力单词测试，走听力的逻辑
        this.listenTest(is_right)
      }
    },
    daojishi () {
      let _that = this
      this.timer = setInterval( ()=> {
        if(this.$route.name!=='word_test'){
            clearInterval(this.timer);
            return;
        }
        let num = parseInt(_that.gameSecond) - 1
        if (num < 10 && num >= 0) {
          num = '0' + num.toString()
        }
        _that.gameSecond = num
        if (parseInt(_that.gameSecond) <= 0) {
          _that.answerAndJudge(false)
        }
      }, 1000)
    },
    startExam () {
      this.exam_detail_url = ''
      this.exam_shuiping_content = '同学的测评水平能写出便条和简单的书信。并且能尝试使用不同的教育资源，从口头和书面材料中提取信息扩展知识，能够解决简单的问题并描述结果。'
      this.exam_shuiping = '高中一年级水平'
      this.exam_rank = 10
      this.zhang_wo_de_ci = 1900
      this.page = 'start-page'
      this.innerAudioContext = new Audio()
      this.timer = ''
      this.type = 0
      this.totalTime = 15
      this.limitTime = 8
      this.gameSecond = 15
      this.answer_percent = 0.8
      this.curNum = 0
      this.maxErrorNum = 10
      this.levelErrorNum = 5
      this.listData = []
      this.totalLevel = 7
      this.curLevel = 0
      this.curLevelErrNum = 0
      this.totalErrorNum = 0
      this.wordCur = {}
      this.selectedIndex = -1
      this.is_unknown_click = 0
      this.canClick = 0
      this.is_hide = 1
      this.lastLevelDidWord = ''
      this.score = 0
      this.isListen = 0
      this.id = 0
      this.listenWordList = []
      this.listenScore = 0

      const loadingHide = this.$message.loading('加载中...', 0)
      getExamWords().then(res => {
        setTimeout(loadingHide)
        if (res.status !== 'success') {
          return false
        }
        this.page = 'testing-page'
        this.innerAudioContext.autoplay = false
        this.innerAudioContext.loop = false
        this.maxErrorNum = res.data.max_err
        this.listData = res.data.list
        this.totalLevel = res.data.list.length
        this.curLevel = 0
        this.curNum = 0
        this.wordCur = res.data.list[0].question[0]
        this.totalTime = res.data.list[0].levle_time
        this.limitTime = res.data.list[0].anwser_time
        this.levelErrorNum = res.data.list[0].lavel_err
        this.answer_percent = res.data.list[0].answer_persent
        this.daojishi()
      })
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    listenTest (is_right) {
      let curNum = this.curNum
      if (is_right) {
        let listenScore = this.listenScore
        this.listenScore = listenScore + 1
      }

      if (curNum < this.listenWordList.length - 1) {
        //下一个
        curNum = curNum + 1
        this.wordCur = this.listenWordList[curNum]
        this.selectedIndex = -1
        this.is_unknown_click = 0
        this.gameSecond = 15
        this.canClick = 0
        this.curNum = curNum
        this.playMp3(this.wordCur.audio)

      } else if (curNum == this.listenWordList.length - 1) {
        //听力单词最后一个，提交获取测试报告
        this.getReport()
        clearInterval(this.timer)
      }
    },
    //单词下一题
    playNext () {
      let curLevel = this.curLevel
      let curNum = this.curNum
      this.wordCur = this.listData[curLevel].question[curNum]
      this.selectedIndex = -1
      this.is_unknown_click = 0
      this.gameSecond = 15
      this.canClick = 0
    },
    isErrorEnd () {
      let totalErrorNum = this.totalErrorNum + 1
      let curLevelErrNum = this.curLevelErrNum + 1
      this.totalErrorNum = totalErrorNum
      this.curLevelErrNum = curLevelErrNum
      if (curLevelErrNum >= this.levelErrorNum) {
        return true
      }
      return totalErrorNum >= this.maxErrorNum
    },
    computeScore () {
      let curLevel = this.curLevel
      let answer_percent = this.answer_percent
      let total = this.listData[curLevel].total
      let totalTime = this.totalTime
      let score = this.score
      if ((totalTime - this.gameSecond) > this.limitTime) {
        score += (answer_percent * (total)) / (this.listData[curLevel].question.length)
        console.log('answer_percent score ', answer_percent * (total),(this.listData[curLevel].question.length))
      } else {
        score += (total) / (this.listData[curLevel].question.length)
        console.log('8秒以下', score)
      }
      console.log('current score:', score)
      this.score = score
    },
    finishWordTest () {
      clearInterval(this.timer)
      let curLevel = this.curLevel
      let curNum = this.curNum
      let wordList = this.listData[curLevel].question
      let lastLevelDidWord = ''
      for (var i = 0; i <= curNum; i++) {
        if (lastLevelDidWord === '') {
          lastLevelDidWord = wordList[i].subject
        } else {
          lastLevelDidWord = lastLevelDidWord + ',' + wordList[i].subject
        }
      }
      let data = {
        score: parseInt(this.score),
        words: lastLevelDidWord,
      }
      if (!data.score) {
        delete data.score
      }
      getListenWords(data).then((res) => {
        let id = res.data.id
        this.id = id
        this.listenWordList = res.data.question
        this.wordCur = res.data.question[0]
        this.isListen = 1
        this.curNum = 0
        this.selectedIndex = -1
        this.is_unknown_click = 0
        this.gameSecond = 15
        this.canClick = 0
        //播放听力测试第一个单词的读音
        this.playMp3(res.data.question[0].audio)
        //开始倒计时
        this.daojishi()
      })
    },
    getReport () {
      const loadingHide = this.$message.loading('报告加载中...', 0)
      let data = {
        score: this.listenScore,
        id: this.id,
      }
      if (!data.score) {
        delete data.score
      }
      submitTestResult(data).then((res) => {
        setTimeout(loadingHide)
        this.playMp3(this.success_mp3)
        this.exam_detail_url = res.data.url
        this.exam_shuiping_content = res.data.advise
        this.exam_shuiping = res.data.ad
        this.exam_rank = res.data.ad_percent
        this.zhang_wo_de_ci = res.data.word_num
        this.page = 'end-page'
      })
    },
    clickOption (e) {
      if (this.canClick === 1) {
        return false
      }
      let index = e.currentTarget.dataset.index
      this.selectedIndex = index
      this.canClick = 1
      console.log('client option index:' + index)
      this.playMp3(this.select_mp3)
      this.selectedIndex = index
      console.log(this.selectedIndex, index)
      //结束倒计时判断是否错误更换题目
      let right = this.wordCur.right_option
      let is_select_right
      if (index == right) {
        is_select_right = true
      } else {
        is_select_right = false
      }
      console.log('select result: ' + is_select_right)
      let _that = this
      setTimeout(function () {
        _that.answerAndJudge(is_select_right)
      }, 200)
    },
    clickUnknown: function (e) {
      this.selectedIndex = -1
      this.is_unknown_click = 1
      this.playMp3(this.select_mp3)
      let _that = this
      setTimeout(function () {
        _that.answerAndJudge(false)
      }, 200)
    },
    playOne: function () {
      this.playMp3(this.wordCur.audio)
    },
    playMp3: function (url) {
      this.innerAudioContext.src = url
      this.innerAudioContext.play()
    },
    viewDetail: function () {
      window.open(this.exam_detail_url)
    }
  }
}
</script>
<style lang="less" scoped>
.word-test {
  background: url(https://777-static.oss-cn-beijing.aliyuncs.com/exam/beijing-img.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.word-test-wrap {
  padding-top: 25px;
}

.word-test-wrap-main {
  width: 800px;
  background-color: #FFFFFF;
  box-shadow: 2px 2px 33px 0 #E1E3EC;
  border-radius: 10px;
  text-align: center;
  padding: 55px;
  position: relative;
  overflow: hidden;

  &.word-test-wrap-main-result {
    background-color: transparent;
    box-shadow: none;
    padding: 0;

    .word-test-result-hd {
      display: flex;
      justify-content: start;
      align-items: center;
      padding: 52.5px;

      .result-student {
        line-height: 80px;
        height: 80px;
        display: flex;

        img {
          height: 80px;
          width: 80px;
          border-radius: 100%;
        }

        .result-username {
          padding-left: 15px;
          font-size: 35px;
          font-weight: 400;
          color: #333333;
        }
      }
    }

    .word-test-result-bd {
      padding: 15px 52.5px 10px;

      .test-you-zhangwodeci {
        display: flex;
        justify-content: start;
        align-items: flex-end;

        .desc {
          margin-left: 45px;
          margin-bottom: 10px;
          font-size: 24px;
          font-weight: 400;
          color: #333333;
        }

        .bili {
          font-size: 29.5px;
          font-weight: 600;
          color: #44CAB1;
          padding: 0 .25px;
        }

        .number {
          position: relative;

          &:after {
            height: 13px;
            width: 105%;
            display: block;
            position: absolute;
            opacity: .85;
            z-index: 0;
            bottom: 4px;
            left: 0;
            content: ' ';
            background: #FFAD25;
            border-radius: 10px;
          }

          b {
            font-size: 80px;
            font-weight: 600;
            color: #333333;
            line-height: 100.6px;
            z-index: 1;
          }

          span {
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 33.6px;
          }
        }
      }

      .text-content {
        width: 100%;
        height: 172px;
        background: rgba(68, 202, 177, 0.2);
        margin-top: 15px;
        position: relative;
        overflow-y: scroll;

        .title {
          top: 0;
          left: 0;
          position: absolute;
          width: 230.6px;
          height: 36px;
          background: #44CAB1;
          border-radius: 0 0 60px 0;
          text-align: center;
          font-size: 20px;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 36px;
        }

        .content {
          top: 40px;
          left: 0;
          padding: 21px;
          text-align: left;
          position: absolute;
        }
      }


      .test-you-cihuiliang {
        display: block;
        width: 100%;
        height: 33.6px;
        font-size: 25px;
        font-weight: 400;
        color: #333333;
        line-height: 33.6px;
        text-align: left;
      }
    }

    .word-test-result-ft {
      padding: 5px 52.5px 5px;
      text-align: center;

      .result-restart-button {
        width: 246px;
        height: 48px;
        border-radius: 100px;
        background-color: #ffffff;
        border: 1px solid #333333;
        outline: none;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        line-height: 33.6px;

        &:active {
          border: none;
          background: #DAF4EF;
        }
      }

      .result-more-button {
        margin-left: 60px;
        width: 246px;
        height: 48px;
        border-radius: 100px;
        border: none;
        outline: none;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        line-height: 33.6px;
        background: linear-gradient(180deg, #71EDD6 0%, #3DD6AC 100%);

        &:active {
          background: linear-gradient(180deg, #71CCBB 0%, #52BB9E 100%);
        }
      }
    }

    .word-test-result-layer {
      position: absolute;
      left: 0;
      top: 0;
      padding: 15px 20px;
      width: 100%;
    }

    .word-test-page-end {
      position: relative;

      .bg-image {
        width: 100%;
      }
    }

  }

  .word-test-page-testing {
    .test-ab-circle {
      display: block;
      position: absolute;
      right: -66px;
      top: -50px;
      border-radius: 50%;
      width: 190px;
      height: 200px;
      border: 28px solid rgba(41, 213, 181, 0.08);
    }

    .test-ab-circle-daojishi {
      display: block;
      position: absolute;
      right: 80px;
      top: 64px;
      height: 36px;
      width: 37px;

      .daojishi {
        font-size: 16.8px;
        font-weight: 600;
        color: #27C2A5;
        position: absolute;
        top: 7px;
        left: 7px;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .test-subject-title {
      height: 67.2px;
      font-size: 48px;
      font-weight: 600;
      color: #27C2A5;
      line-height: 67.2px;
      margin: 0 auto;

      .audio-img {
        height: 60px;
        width: 60px;
        margin: 0 auto;

        img {
          width: 100%;
        }
      }
    }

    .test-options {
      padding: 15px 20px;

      .test-options-option {
        height: 60px;
        position: relative;
        padding: 5px 10px;
        line-height: 60px;
        background: #FFFFFF;
        margin-top: 11.2px;
        display: flex;
        justify-content: start;
        align-items: center;
        border-radius: .5px;

        &.test-options-option-unknown {
          .circle-icon {
            background-color: rgba(255, 173, 37, 1);
          }

          .text {
            color: rgba(255, 173, 37, 1);
          }

        }

        &.touchClass {
          background-color: rgba(68, 202, 177, 0.1);
        }

        .circle-icon {
          height: 14.2px;
          width: 14.2px;
          background-color: #44CAB1;
          border-radius: 100%;
        }

        .text {
          margin-left: 14.6px;
          font-size: 24px;
          font-weight: 600;
          color: #333333;
        }

        &:after {
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          content: ' ';
          height: 1px;
          width: 100%;
          background-color: #E3E3E3;
        }
      }
    }
  }

  .word-test-area-hd img {
    height: 260px;
  }

  .word-test-area-bd {
    .word-test-area-bd-title {
      margin-top: 15px;
      font-size: 54px;
      font-weight: 500;
      color: #000000;
      text-align: center;
    }

    .word-test-area-bd-desc {
      margin-top: 10.8px;
      font-size: 21.6px;
      font-weight: 400;
      color: #333333;
      line-height: 45px;
    }
  }

  .word-test-area-ft {
    margin-top: 42px;

    .start-test-btn {
      outline: none;
      border: none;
      width: 246px;
      height: 48px;
      background: linear-gradient(180deg, #71EDD6 0%, #3DD6AC 100%);
      border-radius: 36px;
      font-size: 24px;
      font-weight: 500;
      color: #FFFFFF;

      &:focus {
        background: linear-gradient(180deg, #71CCBB 0%, #52BB9E 100%);
      }
    }

  }
}
</style>
